import { render, staticRenderFns } from "./class_radar.vue?vue&type=template&id=3813e4f6&scoped=true"
import script from "./class_radar.vue?vue&type=script&lang=js"
export * from "./class_radar.vue?vue&type=script&lang=js"
import style0 from "./class_radar.vue?vue&type=style&index=0&id=3813e4f6&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3813e4f6",
  null
  
)

export default component.exports